// const BASE_URL = process.env.REACT_APP_BASE_URL || "http://35.154.35.158:5000";
const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
export { BASE_URL };
